import { css } from 'styled-components';

const variables = css`
  :root {
    --bg-color: #050505; /* Deep Obsidian Black */
    --surface-color: #121212; /* Slightly lighter for cards */
    --surface-light: #1e1e1e;
    
    --text-main: #ffffff; /* Pure white for high contrast */
    --text-muted: #a1a1aa; /* Zinc 400 for secondary text */
    --text-dark: #52525b; /* Zinc 600 for subtle borders/text */
    
    --accent-main: #8b5cf6; /* Electric Violet */
    --accent-secondary: #06b6d4; /* Bright Cyan */
    --accent-glow: 0 0 30px rgba(139, 92, 246, 0.4);
    
    --gradient-primary: linear-gradient(135deg, var(--accent-main) 0%, var(--accent-secondary) 100%);
    
    --font-heading: 'Syne', 'Inter', sans-serif;
    --font-body: 'Space Grotesk', 'Inter', sans-serif;
    --font-mono: 'Space Mono', 'Fira Code', monospace;

    --fz-xxs: 12px;
    --fz-xs: 14px;
    --fz-sm: 16px;
    --fz-md: 18px;
    --fz-lg: 20px;
    --fz-xl: 24px;
    --fz-xxl: 32px;
    --fz-heading: 48px;
    --fz-massive: clamp(60px, 10vw, 120px);

    --border-radius: 16px;
    --border-radius-lg: 24px;
    
    --nav-height: 100px;
    --nav-scroll-height: 80px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
